import {MetaInfoTypeVo} from '../../common/shared/api/gateway/enums/MetaInfoTypeVo.enum';
import {MetaInfoType, SectionType} from '../generated/types';

export function createMetaInfoType(
  sectionType: SectionType,
  metaInfoTypeVo?: MetaInfoTypeVo
): MetaInfoType {
  // 최근본 섹션은 항상 대분류 노출입니다.
  if (sectionType === SectionType.RecentViewed) {
    return MetaInfoType.Category;
  }
  // 운영툴에서 직접 MetaInfoType 을 세팅하는 테마, 가로스크롤테마 섹션, 카드배너섹션을 제외한 모든 섹션은 view_count 가 있으면 노출하는 정책임.
  if (
    sectionType !== SectionType.HelixTheme &&
    sectionType !== SectionType.Theme &&
    sectionType !== SectionType.ScrollTheme &&
    sectionType !== SectionType.CardBanner
  ) {
    return MetaInfoType.ViewCount;
  }
  // 테마, 가로스크롤테마 섹션은 metaInfoType 이 없으면 무조건 다 숨김처리함(API 스펙)
  if (!metaInfoTypeVo) {
    return MetaInfoType.None;
  }
  return map[metaInfoTypeVo];
}
const map: {[key in MetaInfoTypeVo]: MetaInfoType} = {
  [MetaInfoTypeVo.AuthorName]: MetaInfoType.AuthorName,
  [MetaInfoTypeVo.IssueStatus]: MetaInfoType.IssueStatus,
  [MetaInfoTypeVo.ViewCount]: MetaInfoType.ViewCount,
  [MetaInfoTypeVo.RecommendReason]: MetaInfoType.RecommendReason,
  [MetaInfoTypeVo.CategoryAuthor]: MetaInfoType.CategoryAndAuthor,
  [MetaInfoTypeVo.CategoryViewCount]: MetaInfoType.CategoryAndViewCount,
};
